
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import { whatsapp, ellipsisString, formatByCountry } from "@/app/infrastructures/misc/Utils";
import TableDetail from "../detail/table-detail.vue";
import TransferPickupModal from "../transfer-pickup/component/modal.vue";
import { Pagination } from "@/domain/entities/Pagination";
import { PickupDashboardController } from "@/app/ui/controllers/PickupDashboardController";
import formatDateNumber from "@/app/infrastructures/misc/common-library/FormatDateNumber";
import {
  CourierSummaryRequest,
  ShipmentListRequest
} from "@/data/payload/api/PickupDashboardRequests";
import ErrorMessage from "@/app/ui/components/error-message/index.vue";
import { INTERNAL_SERVER_ERROR as INTERNAL_SERVER_ERROR_CONST } from "@/app/infrastructures/misc/Constants";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";

@Options({
  components: { TableDetail, ErrorMessage, TransferPickupModal }
})
class PickupDashboardMonitoringCourierDetailCRROTW extends Vue {
  INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR_CONST as string;
  formatPhoneNumber = formatPhoneNumber;
  sortBy = "total_shipment" as string;
  sortDir = "desc" as "asc" | "desc" | "";
  pagination = new Pagination(1, 20, 0);
  nowTs = Date.now() as number;
  listData: any[] = [];
  isLoading = false;
  error = "" as string;
  filterStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  filterEnd = new Date();
  lastFetchKey = "";
  pendingKey = "";
  readyForUserSort = false;
  showTransferModal = false;
  selectedSellersForTransfer: any[] = [];

  intervalId: any = null;

  get selectedCount() {
    try {
      return (this.listData || []).filter((d: any) => Boolean(d.is_checked))
        .length;
    } catch (_) {
      return 0;
    }
  }
  get columns() {
    return [
      { key: "checkbox", name: "", styleHead: "w-10 text-left" },
      {
        key: "no",
        name: "pickupDashboard.column.no",
        styleHead: "w-16 text-left"
      },
      {
        key: "sender_name",
        name: "pickupDashboard.column.senderName",
        sortable: true
      },
      {
        key: "shipment_type",
        name: "pickupDashboard.column.shipmentType",
        render: undefined
      },
      {
        key: "total_shipment",
        name: "pickupDashboard.column.totalShipment",
        sortable: true,
        styleHead: "w-20 text-left",
        styleBody: "w-20 text-left px-4 py-2"
      },
      {
        key: "expired_at",
        name: "pickupDashboard.column.remainingTime",
        sortable: true
      },
      {
        key: "sender_address",
        name: "pickupDashboard.column.address",
        render: undefined
      },
      {
        key: "actionable_column",
        name: "pickupDashboard.column.transferPickUp",
        styleHead: "text-center",
        styleCustom: "justify-center gap-3",
        render: undefined
      }
    ];
  }

  get courierId() {
    return Number(this.$route.params.id || 1);
  }

  get startIndex() {
    return (this.pagination.page - 1) * this.pagination.limit;
  }

  get pagedData() {
    return this.listData;
  }

  mounted() {
    this.intervalId = setInterval(() => {
      this.nowTs = Date.now();
    }, 1000);
    this.$watch(
      () => this.$route.query,
      (_newQ: Record<string, any>, _oldQ: Record<string, any>) => {
        this.pagination.page = 1;
        this.fetchData();
      },
      { deep: false, immediate: true }
    );
  }

  unmounted() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  onSort(key: string) {
    if (this.sortBy !== key) {
      this.sortBy = key;
      this.sortDir = "asc";
    } else if (this.sortDir === "asc") {
      this.sortDir = "desc";
    } else {
      this.sortBy = "";
      this.sortDir = "";
    }
    this.fetchData();
  }

  remainingSeconds(item: any) {
    const diff = new Date(item.expired_at).getTime() - this.nowTs;
    return diff > 0 ? Math.floor(diff / 1000) : 0;
  }

  formatRemaining(sec: number) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = Math.floor(sec % 60);
    const pad = (v: number) => String(v).padStart(2, "0");
    return `${pad(h)} : ${pad(m)} : ${pad(s)}`;
  }

  mapsHref(item: any) {
    if (item.lat && item.lon) {
      return `https://www.google.com/maps?q=${item.lat},${item.lon}`;
    }
    const q = encodeURIComponent(item.sender_address || "");
    return `https://www.google.com/maps/search/?api=1&query=${q}`;
  }

  onOpenWa(phone: string) {
    whatsapp(phone);
  }

  formatShipmentType(val: string) {
    if (!val) return "-";
    const lower = String(val).toLowerCase();
    const normalized = lower.replace(/_/g, " ");
    return normalized.replace(/\b\w/g, (l) => l.toUpperCase());
  }

  onSelectToggle(item: any) {
    try {
      const idx = (this.listData || []).findIndex((d: any) => d === item);
      if (idx >= 0) {
        this.listData[idx].is_checked = !this.listData[idx].is_checked;
        this.listData = [...this.listData];
      }
    } catch (_) {
      // ignore
    }
  }

  onToggleSelectAll(checked: boolean) {
    try {
      (this.pagedData || []).forEach((d: any) => {
        d.is_checked = checked;
      });
      this.listData = [...this.listData];
    } catch (_) {
      // ignore
    }
  }

  onSetPage(p: number) {
    this.pagination.page = p;
    this.fetchData();
  }

  onTransferPickUpRow(item: any) {
    this.selectedSellersForTransfer = [
      {
        id: item.task_group_id?.toString() || "0",
        sellerName: item.sender_name || "-",
        sellerPhone: item.sender_phone || "-",
        packageCount: Number(item.total_shipment || 0),
        koli: Number(item.total_quantity || 0),
        weight: Number(item.total_weight || 0),
        taskGroupId: item.task_group_id,
        index: 0
      }
    ];
    this.showTransferModal = true;
  }

  onBulkTransferPickUp() {
    const checkedItems = (this.listData || []).filter((d: any) =>
      Boolean(d.is_checked)
    );

    this.selectedSellersForTransfer = checkedItems.map(
      (item: any, index: number) => ({
        id: item.task_group_id?.toString() || "0",
        sellerName: item.sender_name || "-",
        sellerPhone: item.sender_phone || "-",
        packageCount: Number(item.total_shipment || 0),
        koli: Number(item.total_quantity || 0),
        weight: Number(item.total_weight || 0),
        taskGroupId: item.task_group_id,
        index: index
      })
    );

    this.showTransferModal = true;
  }

  onRemoveSellerFromTransfer(sellerIndex: number) {
    this.selectedSellersForTransfer = this.selectedSellersForTransfer.filter(
      (seller) => seller.index !== sellerIndex
    );
  }

  onTransferSuccess() {
    // Clear selections
    this.selectedSellersForTransfer = [];
    this.showTransferModal = false;
    this.listData = this.listData.map((d: any) => ({
      ...d,
      is_checked: false
    }));

    // Refresh data
    this.lastFetchKey = "";
    this.fetchData();
    this.fetchSummary();
  }

  get isFiltering() {
    const { q, shipmentType, start, end } = this.getRouteQuery();
    return Boolean(q || shipmentType || start || end);
  }

  private getRouteQuery() {
    const cid = Number(this.$route.params.id || 0);
    const start = String(this.$route.query.start_date || "");
    const end = String(this.$route.query.end_date || "");
    const q = String(this.$route.query.q || "");
    const shipmentType = String(this.$route.query.shipment_type || "");
    return { cid, start, end, q, shipmentType };
  }

  private buildFetchKey(args: {
    cid: number;
    start: string;
    end: string;
    q: string;
    shipmentType: string;
  }) {
    return [
      args.cid,
      args.start,
      args.end,
      args.q,
      args.shipmentType,
      this.pagination.page,
      this.pagination.limit,
      this.sortBy,
      this.sortDir
    ].join("|");
  }

  private isArgsMissing(args: { cid: number; start: string; end: string }) {
    return !args.cid;
  }

  private shouldSkipFetch(key: string) {
    if (this.pendingKey === key) return true;
    if (this.lastFetchKey === key) return true;
    return false;
  }

  private createListRequest(
    status: string,
    args: {
      cid: number;
      start: string;
      end: string;
      q: string;
      shipmentType: string;
    }
  ) {
    return new ShipmentListRequest({
      courierId: args.cid,
      startDate: args.start,
      endDate: args.end,
      status,
      q: args.q,
      shipmentType: args.shipmentType,
      page: this.pagination.page,
      limit: this.pagination.limit,
      sortBy: this.sortDir.toUpperCase(),
      orderBy: this.sortBy
    });
  }

  private updateListFromResponse(res: any) {
    this.listData = Array.isArray(res.data)
      ? res.data.map((d: any) => ({ ...d, is_checked: Boolean(d.is_checked) }))
      : [];
    this.pagination = new Pagination(
      res.pagination.page || this.pagination.page,
      res.pagination.limit || this.pagination.limit,
      res.pagination.totalData || 0
    );
  }

  private async safeRunFetch(status: string) {
    try {
      this.error = "";
      const args = this.getRouteQuery();
      if (this.isArgsMissing(args)) return;
      const key = this.buildFetchKey(args);
      if (this.shouldSkipFetch(key)) return;
      this.isLoading = true;
      this.pendingKey = key;
      this.lastFetchKey = key;
      const params = this.createListRequest(status, args);
      const res = await PickupDashboardController.getShipmentList(params);
      this.updateListFromResponse(res);
    } catch (e) {
      const msg =
        (e as any)?.message || String(this.$t("pickupDashboard.systemError"));
      this.error = msg;
    } finally {
      this.isLoading = false;
      this.pendingKey = "";
      this.readyForUserSort = true;
    }
  }

  async fetchData() {
    await this.safeRunFetch("CRROTW");
  }

  fmtQty(val: number | string) {
    return formatByCountry(Number(val || 0), { type: "quantity" });
  }

  ellipsis(val: string) {
    return ellipsisString(val, 70);
  }

  async fetchSummary() {
    const cf = PickupDashboardController.currentFilter;
    const start = cf.startDate;
    const end = cf.endDate;
    const cid = Number(this.$route.params.id || 0);
    const params = new CourierSummaryRequest({
      startDate: typeof start === "string" ? start : formatDateNumber(start),
      endDate: typeof end === "string" ? end : formatDateNumber(end),
      courierId: Number(cf.courierId || cid),
      status: "CRROTW,CRRPIC,CRRDON",
      q: String(cf.q || ""),
      shipmentType: String(cf.shipmentType || "")
    });
    await PickupDashboardController.getCourierSummary(params);
  }
}
export default PickupDashboardMonitoringCourierDetailCRROTW;
